import PropTypes from "prop-types"

/**
 * PropTypes for StopSessionModal component.
 * @typedef {Object} StopSessionModalProps
 * @property {boolean} isOpen - Whether the modal is open
 * @property {Function} onClose - Callback to close the modal without stopping
 * @property {Function} onConfirm - Callback to confirm stopping the session
 * @property {boolean} [isSubmitting=false] - Whether the stop request is in-flight
 */
export const stopSessionModalPropTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	isSubmitting: PropTypes.bool,
}

/**
 * PropTypes for ReceiptSummary component.
 * @typedef {Object} ReceiptSummaryProps
 * @property {Object} [receipt] - Receipt breakdown from the public session status response
 * @property {number} receipt.energyCost - Cost attributed to delivered energy
 * @property {number} receipt.timeCost - Cost attributed to charging time
 * @property {number} receipt.parkingCost - Cost attributed to parking time
 * @property {number} receipt.fixedCost - Fixed/activation cost
 * @property {number} receipt.vat - VAT of the whole charge
 * @property {number} receipt.totalCost - Total charged amount
 * @property {Object|null} [receipt.priceLines] - CEME price list lines, each { net, vat }, null outside price list mode
 * @property {number} receipt.kwh - Energy delivered, in kWh
 * @property {string} receipt.currency - Currency code (e.g. EUR)
 */
export const receiptSummaryPropTypes = {
	receipt: PropTypes.shape({
		energyCost: PropTypes.number,
		timeCost: PropTypes.number,
		parkingCost: PropTypes.number,
		fixedCost: PropTypes.number,
		vat: PropTypes.number,
		totalCost: PropTypes.number,
		priceLines: PropTypes.object,
		kwh: PropTypes.number,
		currency: PropTypes.string,
	}),
}
